export default __webpack_public_path__ + "static/hero-9321962d4216d239098c7cb180f2ce41.jpg";